import React, { useState, useEffect } from 'react';
import StbMaxEnquiry from './StbMaxEnquiry';
import StbMaxActivated from './StbMaxActivated';
import StbMaxNotActivated from './StbMaxNotActivated';
import StbMaxError from './StbMaxError';
import StbMaxExpired from './StbMaxExpired';
import { getStbSubInfo } from '../../Services/StbPartnerService';
import { translations } from '../Text/translations';
import '../../css/max.scss';
import maxActivationImage from '../../assets/max/Max-Activation.png';

const StbMax = ({ currentLang = 'en', token }) => {
    const [subscribedInd, setSubscribedInd] = useState('');
    const [activationStatus, setActivationStatus] = useState('');
    const [loading, setLoading] = useState(true);
    const [tokenExpired, setTokenExpired] = useState(false);

    useEffect(() => {
        if (!token) {
            setSubscribedInd('N');
            setLoading(false);
            return;
        }

        setLoading(true);
        getStbSubInfo(token)
            .then((subInfoResponse) => {
                if (subInfoResponse.responseCode === 'TOKEN_EXPIRED') {
                    setTokenExpired(true);
                    setLoading(false);
                } else if (subInfoResponse.responseCode === 'SUCCESS') {
                    if (subInfoResponse.subscribedInd) {
                        setSubscribedInd(subInfoResponse.subscribedInd);
                    }
                    if (subInfoResponse.activationStatus) {
                        setActivationStatus(subInfoResponse.activationStatus);
                    }
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLoading(false);
            });
    }, [token]);

    useEffect(() => {
        if (loading) {
            document.body.classList.add('page-load');
        } else {
            document.body.classList.remove('page-load');
        }
        return () => {
            document.body.classList.remove('page-load');
        };
    }, [loading]);

    useEffect(() => {
        const isExpiredPage = !loading && tokenExpired;
        
        if (isExpiredPage) {
            document.documentElement.classList.add('stb-max-no-scroll-always');
            document.body.classList.add('stb-max-no-scroll-always');
        } else {
            document.documentElement.classList.remove('stb-max-no-scroll-always');
            document.body.classList.remove('stb-max-no-scroll-always');
        }
        
        return () => {
            document.documentElement.classList.remove('stb-max-no-scroll-always');
            document.body.classList.remove('stb-max-no-scroll-always');
        };
    }, [loading, tokenExpired]);

    return (
        <div className={`page-wrapper stb-max-page-wrapper`}>
            <div className="container">
                {loading ? (
                    <div className="loading-wrapper show inline">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className='max-wrapper'>
                        {tokenExpired && <StbMaxExpired currentLang={currentLang} />}

                        {!tokenExpired && (
                            <>
                                {subscribedInd === 'N' && (
                                    <div className='message'>
                                        <h2>{translations[currentLang].maxSubscriptionNotFound}</h2>
                                        <p>{translations[currentLang].maxNoSubscription}</p>
                                    </div>
                                )}

                                {subscribedInd === 'Y' && activationStatus === 'Activated' && (
                                    <StbMaxActivated currentLang={currentLang} />
                                )}

                                {subscribedInd === 'Y' && activationStatus === 'Enrolled' && (
                                    <StbMaxNotActivated currentLang={currentLang} token={token} />
                                )}

                                {subscribedInd === 'Y' && activationStatus !== 'Activated' && activationStatus !== 'Enrolled' && (
                                    <div className="preview-img">
                                        <img src={maxActivationImage} alt="" />
                                    </div>
                                )}

                                {subscribedInd !== 'N' && subscribedInd !== 'Y' && <StbMaxError currentLang={currentLang} />}
                            </>
                        )}
                    </div>
                )}
            </div>

            {!loading && !tokenExpired && subscribedInd === 'N' && (
              <StbMaxEnquiry currentLang={currentLang} />
            )}
        </div>
    );
};

export default StbMax;
